import { render, staticRenderFns } from "./PromocaoParceiroCard.vue?vue&type=template&id=5cc11180&"
import script from "./PromocaoParceiroCard.vue?vue&type=script&lang=js&"
export * from "./PromocaoParceiroCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports